<template>
  <div class="age-check-failed-container">
    <div class="logo-container">
      <img :src="logo" alt="logo" class="logo" />
    </div>
    <div class="lower-container">
      <div class="failed-header">
        {{ $t("age_check_failed.failed_header") }}
      </div>
      <div class="failed-content">
        {{ $t("age_check_failed.failed_content") }}
      </div>
      <div class="close-button-container">
        <button type="button" class="close-button" @click="handleButtonClick">
          GOT IT
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/images/logo_jaegermeister_white.svg";
import close from "@/assets/images/close.svg";
export default {
  data() {
    return {
      logo: logo,
      close: close,
    };
  },
  methods: {
    handleButtonClick() {
      this.$store.state.sounds.tapSound.play();
      location.reload();
    },
  },
};
</script>

<style scoped>
.age-check-failed-container {
  text-align: center;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10rem;
  align-items: center;
  height: 70vh;
}

.logo-container {
  margin-bottom: 1rem;
}

.logo {
  width: 100px;
}

.failed-header {
  font-weight: bold;
  font-size: 3.5rem;
  line-height: 1;
  margin-bottom: 1rem;
}

/* .failed-subheader {
  font-weight: bold;
  font-size: 4rem;
  line-height: 1;
  margin: 1rem 0;
} */

.failed-content {
  padding: 0 3.5rem;
  font-size: 1.75rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-weight: 300;
}

.close-button-container {
  margin-top: 1rem;
}

.close-button {
  display: flex;
  align-items: center;
  width: 30rem;
  justify-content: center;
  color: black;
  --tw-bg-opacity: 1;
  background-color: white;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 10rem;
  padding-right: 10rem;
  border: none;
  cursor: pointer;
  border-radius: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  font-family: "Meister";
}

.close-icon {
  border-radius: 50%;
  width: 60px;
  height: 60px;
}

.lower-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
}
</style>
